import React from 'react'
import {fetchPlanIcon} from '../../../utils/fetch-plan-icon'
// import {currencySymbolsEnum} from '../kp-11-link/kp-11Link-utility/kp11-utility'
import {formatPrice} from '../../../utils/currency-format'

export const ProductNamePriceComponent = ({
  cardDetail,
  customFields,
  currency,
  isIconRequired = true,
  isNameRequired = true,
  disabled = false,
  country,
}) => {
  const formattedLabel = text =>
    text
      ?.replace(/marketing center/gi, '')
      .replace(/growth package/gi, '')
      .replace(/thryv leads/gi, 'Proposal Amount')
      .replace(/aeo & seo/gi, 'Proposal Amount')
      .trim() || ''
  const billingType = 'Billed Monthly'
  let iconDetail = fetchPlanIcon(cardDetail.name) || {}

  const isSEO = cardDetail?.code === 'seobase-5-thryv-m2m' ? true : false
  const isThryvLeads =
    cardDetail?.code === 'tl-mc-5-thryv-m2m' ||
    cardDetail?.code === 'tl-tax-5-thryv-m2m' ||
    cardDetail?.code === 'tl-5-thryv-m2m'
  const targetCurrency = currency || cardDetail?.currency || 'USD'

  const getAmountWithCurrencySymbol = (
    prices,
    customFields,
    currency = 'USD',
  ) => {
    const price = prices?.find(p => p.currency === currency)

    if (!price) return null
    // const symbol = currencySymbolsEnum[currency] || ''
    if (isSEO) {
      // return `${symbol}${price.unitAmount * customFields?.alphaAmount}`
      return formatPrice(
        price.unitAmount * customFields?.alphaAmount,
        1,
        '',
        country,
      )
    }
    if (isThryvLeads) {
      // return `${symbol}${price.unitAmount * customFields?.thryvLeadAmount}`
      return formatPrice(
        price.unitAmount * customFields?.thryvLeadAmount,
        1,
        '',
        country,
      )
    }
    // return `${symbol}${price.unitAmount}`
    return formatPrice(price.unitAmount, 1, '', country)
  }
  return (
    <div
      className={`d-flex justify-content-between w-100 ${
        disabled ? 'disabled' : ''
      }`}
    >
      <div className="d-flex justify-content-between w-100">
        <div className="item-content-wrap">
          <div
            className="d-flex align-items-center"
            style={{
              marginTop:
                iconDetail?.icon && !isSEO && !isThryvLeads ? '-15px' : '0px',
            }}
          >
            {isIconRequired && iconDetail?.icon && (
              <div className="card-icon">
                <img
                  src={iconDetail?.icon}
                  alt="plan logo"
                  className="options-logo rounded"
                  style={{height: '50px', width: '50px'}}
                />
              </div>
            )}
            {isNameRequired && (
              <div className="plan-item-radio-label">
                {formattedLabel(cardDetail?.name)}
              </div>
            )}
          </div>

          <div className="plan-item-price">
            {getAmountWithCurrencySymbol(
              cardDetail?.currencies,
              customFields,
              targetCurrency,
            )}
          </div>
          <div className="plan-item-subtext">
            {cardDetail?.billingType || billingType}
          </div>
        </div>
      </div>
    </div>
  )
}
